export default {
    data() {
        return {
            dataTableFooterProps: {
                'items-per-page-text': 'Filas por página:',
                'aria-label': {
                    sortDescending: ': Orden descendente. Activar para eliminar orden.',
                    sortAscending: ': Orden ascendente. Activar para ordenar descendente.',
                    sortNone: ': Sin orden. Activar para ordenar ascendente.',
                }, 'sort-by': 'Ordenar por'
            }
        };
    }
};